import { createSlice } from '@reduxjs/toolkit'
import { updateOnSave } from 'apps/builder/store/actions/app'
import { styleDefaults } from 'apps/easyForm/lib/utils/styles'

export const DEFAULT_WIDTH = 150
export const DEFAULT_HEIGHT = 50

export const initialState = {
  id: null,
  pdf_path: null,
  form_id: null,
  styles: styleDefaults,
  position: {
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT,
  },
}

// TODO: This may be better handled at the input level, but
// for now we're just ensuring that the position values are numbers.
export const ensureNumber = update => {
  let numberUpdates = {}
  Object.keys(update).forEach(key => {
    numberUpdates[key] = Number(update[key])
  })
  return numberUpdates
}

export const pdfSlice = createSlice({
  name: 'pdf',
  initialState,
  reducers: {
    addPDF(state, action) {
      // TODO: We may ultimately want this as a thunk that uploads the PDF and
      // returns the hosted URL.
      const { pdf_path } = action.payload
      return {
        ...initialState,
        form_id: state.form_id,
        pdf_path,
      }
    },
    resetPdf(state, _) {
      return {
        ...state,
        styles: styleDefaults,
        position: {
          width: DEFAULT_WIDTH,
          height: DEFAULT_HEIGHT,
        },
      }
    },
    updateGlobalStyles(state, action) {
      return {
        ...state,
        styles: {
          ...state.styles,
          ...action.payload,
        },
      }
    },
    updateGlobalPosition(state, action) {
      return {
        ...state,
        position: {
          ...state.position,
          ...ensureNumber(action.payload),
        },
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(updateOnSave, (state, action) => {
      const { id: form_id } = action.payload
      return {
        ...state,
        form_id,
      }
    })
  },
})

const { actions, reducer } = pdfSlice

export const pdfActions = actions
export const pdfReducer = reducer
